function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useRef, useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
export var useIntersection = function useIntersection(nodeRef) {
  var triggerOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var observerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var observerRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isIntersecting = _useState2[0],
      setIsIntersecting = _useState2[1]; // check for IntersectionObserver available


  if (typeof IntersectionObserver === 'undefined') {
    if (!isIntersecting) setIsIntersecting(true);
  }

  var observerCallback = useCallback(function (_ref, observer) {
    var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];

    // the first element is the element to observe
    if (entry && entry.isIntersecting) {
      setIsIntersecting(true);

      if (triggerOnce) {
        observer.unobserve(entry.target);
      }
    } else {
      setIsIntersecting(false);
    }
  }, [triggerOnce]); // create new observer on mount and cleanup on unmount

  useEffect(function () {
    var currentNode = nodeRef.current;

    if (IntersectionObserver && currentNode) {
      observerRef.current = new IntersectionObserver(observerCallback, observerOptions);
      observerRef.current.observe(currentNode);
    }

    return function () {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = undefined;
      }
    };
  }, [nodeRef, observerCallback, observerOptions]);
  return [isIntersecting];
};

var Observer = function Observer(_ref3) {
  var children = _ref3.children,
      options = _ref3.options,
      observerRef = _ref3.observerRef,
      triggerOnce = _ref3.triggerOnce;

  var _useIntersection = useIntersection(observerRef, triggerOnce, options),
      _useIntersection2 = _slicedToArray(_useIntersection, 1),
      isIntersecting = _useIntersection2[0];

  return children(isIntersecting);
};

Observer.propTypes = {
  children: PropTypes.func.isRequired,
  options: PropTypes.shape({
    rootMargin: PropTypes.string
  }),
  observerRef: PropTypes.object.isRequired,
  triggerOnce: PropTypes.bool
};
Observer.defaultProps = {
  options: {},
  triggerOnce: false
};
export default Observer;